import { EndpointBuilder } from '@reduxjs/toolkit/query/react';
import { ApiBaseQuery, ApiTagTypes } from '../types';
import { SendNotificationRequest } from './types';

/**
 * Endpoints для отправки уведомлений
 */
export const notificationEndpoints = (builder: EndpointBuilder<ApiBaseQuery, ApiTagTypes, 'api'>) => ({
    /**
     * Отправка письма по шаблону
     * POST /private/notification
     */
    sendNotification: builder.mutation<void, SendNotificationRequest>({
        query: (body) => ({
            url: '/private/notification',
            method: 'POST',
            body,
        }),
    }),
});
